import React from 'react';

interface BoletoFormProps {
  price?: number;
}

const BoletoForm: React.FC<BoletoFormProps> = ({
  price,
}) => {
  return (
    <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
      <div className="p-4 text-sm rounded-lg bg-gray-200 border-gray-600 border">
        <span className="font-semibold text-gray-600 dark:text-gray-1000">
          Somente quando recebermos a confirmação, em até 48h após o pagamento, seguiremos com o envio das suas compras. O prazo de entrega passa a ser contado somente após a confirmação do pagamento.
        </span>
        {price && (
          <div className="mt-2">
            Valor no boleto: <div className="inline-block text-green-600 font-bold"> R$ {price.toFixed(2).replace('.', ',')}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BoletoForm; 